import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent } from "vue"
import _imports_0 from '@/assets/icons/icon-arrow-back.svg'


const _hoisted_1 = { class: "lot-page-wr lot-block-wrapper" }
const _hoisted_2 = { class: "lot-wr" }
const _hoisted_3 = { class: "dashboard-header" }
const _hoisted_4 = { class: "title-wr" }
const _hoisted_5 = { class: "title-block" }
const _hoisted_6 = { class: "title-main" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 0,
  class: "title-controls"
}
const _hoisted_9 = { class: "wrapper-switch" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  key: 0,
  class: "switch-count"
}
const _hoisted_12 = { class: "spinner" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "wrapper-back",
              onClick: $setup.toStage
            }, [...(_cache[34] || (_cache[34] = [
              _createElementVNode("div", { class: "back" }, [
                _createElementVNode("img", { src: _imports_0 }),
                _createElementVNode("span", { class: "back-title" }, "Back")
              ], -1)
            ]))]),
            _createElementVNode("h2", _hoisted_6, "Lot " + _toDisplayString($setup.lot ? $setup.lot.title : ""), 1),
            _createElementVNode("div", {
              class: _normalizeClass(["badge big", $setup.getLotStatusClass($setup.lot ? ($setup.lot.status === $setup.LotStatus.EOI ? $setup.LotStatus.PRE_CONTRACT : $setup.lot.status) : '')])
            }, _toDisplayString($setup.getLotStatus), 3),
            ($setup.getBusinessNameFromLot($setup.lot, $setup.businesses) !== '-')
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "badge big",
                  style: _normalizeStyle({ backgroundColor: $setup.getBusinessColorFromLot($setup.lot, $setup.businesses) })
                }, _toDisplayString($setup.getBusinessNameFromLot($setup.lot, $setup.businesses)), 5))
              : _createCommentVNode("", true),
            ($setup.lot?.status === $setup.LotStatus.OFFLINE)
              ? (_openBlock(), _createBlock($setup["DropDown"], { key: 1 }, {
                  control: _withCtx(() => [
                    _createElementVNode("button", {
                      class: _normalizeClass(["dropdown-button badge big", $setup.getLotStatusClass($setup.lot?.offlineSale?.salePhase ? $setup.lot.offlineSale.salePhase : '')])
                    }, _toDisplayString($setup.lot?.offlineSale?.salePhase === $setup.LotStatus.EOI? $setup.LotStatus.HOLD
: $setup.lot?.offlineSale?.salePhase), 3)
                  ]),
                  dropdown: _withCtx(() => [
                    _createElementVNode("ul", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.OfflinePhase, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                          class: _normalizeClass(["phase-list-item", { selected: item === $setup.lot?.offlineSale?.salePhase }]),
                          onClick: ($event: any) => ($setup.changeOfflinePhase(item))
                        }, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["badge badge-list-item", $setup.getLotStatusClass(item)])
                          }, _toDisplayString(item === $setup.LotStatus.EOI ? $setup.LotStatus.HOLD : item), 3)
                        ], 10, _hoisted_7))
                      }), 256))
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        ($setup.lot && $setup.canManageLot)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              ($setup.lot.status === $setup.LotStatus.AVAILABLE || $setup.lot.status === $setup.LotStatus.HOLD)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 0,
                    class: "button default primary",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.showSendContractFormModal = true))
                  }, "Send Contract Form"))
                : _createCommentVNode("", true),
              ($setup.canTransferLot)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 1,
                    class: "button default control",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.showTransferOwnershipModal = true)),
                    onClose: $setup.onCloseTransferOwnershipModal
                  }, "Transfer Ownership", 32))
                : _createCommentVNode("", true),
              ($setup.lot.status !== $setup.LotStatus.SETTLED)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 2,
                    class: "button default control edit",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.showEdit = true))
                  }, "Edit"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.NOT_RELEASED)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 3,
                    class: "button default control",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.showReleaseModal = true))
                  }, "Release Lot"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.NOT_RELEASED)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 4,
                    class: "button default control",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.showConfirmMakeOffline = true))
                  }, "Manage Offline"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.AVAILABLE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 5,
                    class: "button default control",
                    onClick: $setup.checkForUnrelease
                  }, "Unrelease Lot"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.NOT_RELEASED || $setup.lot.status === $setup.LotStatus.AVAILABLE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 6,
                    class: "button default control",
                    onClick: $setup.checkForCreateOption
                  }, "Create Option"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.AVAILABLE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 7,
                    class: "button default control",
                    onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.showCreateInitialHoldModal = true))
                  }, "Create Hold"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.EOI)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 8,
                    class: "button default control",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.showConfirmActionModal = 'revokeEoi'))
                  }, "Revoke Reservation"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.EOI)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 9,
                    class: "button default control",
                    onClick: $setup.generateContract
                  }, "Generate Contract form"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.CONTRACT_EXECUTED || $setup.lot.status === $setup.LotStatus.UNCONDITIONAL)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 10,
                    class: "button default control",
                    onClick: _cache[7] || (_cache[7] = ($event: any) => ($setup.showConfirmActionModal = 'returnPreviousStatus'))
                  }, "Back To " + _toDisplayString($setup.getLotPreviousStatus($setup.lot.status)=== $setup.LotStatus.EOI
? $setup.LotStatus.PRE_CONTRACT
: $setup.getLotPreviousStatus($setup.lot.status)) + " Step", 1))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.CONTRACT_EXECUTED || $setup.lot.status === $setup.LotStatus.UNCONDITIONAL)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 11,
                    class: "button default control",
                    onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.showConfirmActionModal = 'cancelContract'))
                  }, "Terminate Contract"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.OPTION)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 12,
                    class: "button default control",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.showConfirmActionModal = 'cancelOption'))
                  }, "Cancel Option"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 13,
                    class: "button default control",
                    onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.showConfirmActionModal = 'cancelOffline'))
                  }, "Cancel Offline-mode"))
                : _createCommentVNode("", true),
              ($setup.lot.status === $setup.LotStatus.OFFLINE)
                ? (_openBlock(), _createElementBlock("button", {
                    key: 14,
                    class: "button default control",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.showConfirmActionModal = 'markSettled'))
                  }, "Mark as Settled"))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode($setup["LotLifecycle"], { lot: $setup.lot }, null, 8, ["lot"]),
      _createElementVNode("div", _hoisted_9, [
        _createVNode($setup["SwitchComponent"], {
          modelValue: $setup.currentTab,
          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.currentTab) = $event)),
          list: $setup.tabs,
          slots: ['customSwitch']
        }, {
          customSwitch: _withCtx((item) => [
            _createElementVNode("span", {
              class: "switch-item--text",
              onClick: ($event: any) => ($setup.toTab(item.label))
            }, [
              _createTextVNode(_toDisplayString(item.label), 1),
              (item.count)
                ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.count), 1))
                : _createCommentVNode("", true)
            ], 8, _hoisted_10)
          ]),
          _: 1
        }, 8, ["modelValue", "list"])
      ])
    ], 512), [
      [_vShow, !$setup.loading]
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
      [_vShow, $setup.loading]
    ]),
    _createVNode($setup["LotAssignmentModal"], {
      "is-open": $setup.showConfirmMakeOffline,
      onClose: _cache[13] || (_cache[13] = ($event: any) => ($setup.showConfirmMakeOffline = false)),
      onConfirm: $setup.makeOffline
    }, {
      title: _withCtx(() => [...(_cache[35] || (_cache[35] = [
        _createElementVNode("span", { class: "text-semi-bold" }, "Confirm action", -1)
      ]))]),
      description: _withCtx(() => [...(_cache[36] || (_cache[36] = [
        _createElementVNode("span", null, "Are you sure you want to manage this lot offline? Purchasers cannot submit hold requests on offline lots. You can undo this action at any time by clicking 'Cancel Offline-mode'.", -1)
      ]))]),
      _: 1
    }, 8, ["is-open"]),
    _createVNode($setup["EditLotModal"], {
      isOpen: $setup.showEdit,
      lot: $setup.lot,
      eois: $setup.eois?.eois,
      onClose: _cache[14] || (_cache[14] = ($event: any) => ($setup.showEdit = false)),
      onUpdate: $setup.getLot,
      onLoading: _cache[15] || (_cache[15] = ($event: any) => ($setup.loading = true)),
      onOffLoading: _cache[16] || (_cache[16] = ($event: any) => ($setup.loading = false))
    }, null, 8, ["isOpen", "lot", "eois"]),
    _createVNode($setup["CreateOptionModal"], {
      onClose: _cache[17] || (_cache[17] = ($event: any) => ($setup.closeCreateOptionModal($event))),
      onLoading: _cache[18] || (_cache[18] = ($event: any) => ($setup.loading = true)),
      isOpen: $setup.showCreateOptionModal,
      showClose: false,
      listForUpdate: $setup.createOptionObject,
      registrationDate: $setup.lot ? $setup.formatDate($setup.lot.stageId.registrationDate) : ''
    }, null, 8, ["isOpen", "listForUpdate", "registrationDate"]),
    _createVNode($setup["LotDetailsConfirmModal"], {
      onClose: _cache[19] || (_cache[19] = ($event: any) => ($setup.showConfirmActionModal = '')),
      onConfirm: $setup.getLot,
      onLoading: _cache[20] || (_cache[20] = ($event: any) => ($setup.loading = true)),
      onShowCancelContractModal: _cache[21] || (_cache[21] = ($event: any) => ($setup.onShowCancelContractModal($event))),
      showModal: $setup.showConfirmActionModal,
      lot: $setup.lot
    }, null, 8, ["showModal", "lot"]),
    _createVNode($setup["ReleaseLotsModal"], {
      onClose: _cache[22] || (_cache[22] = ($event: any) => ($setup.closeReleaseModal($event))),
      onLoading: _cache[23] || (_cache[23] = ($event: any) => ($setup.loading = true)),
      isOpen: $setup.showReleaseModal,
      showClose: false,
      listForUpdate: [{ id: $setup.lotId }],
      stageId: $setup.stageId
    }, null, 8, ["isOpen", "listForUpdate", "stageId"]),
    _createVNode($setup["TransitionModal"], {
      onProceed: $setup.checkProceedModal,
      onClose: _cache[24] || (_cache[24] = ($event: any) => ($setup.showTransitionModal = false)),
      isOpen: $setup.showTransitionModal,
      showClose: false,
      attentionType: $setup.attentionType,
      lot: $setup.lot
    }, null, 8, ["isOpen", "attentionType", "lot"]),
    ($setup.canManageLot && $setup.hasCollaborator)
      ? (_openBlock(), _createBlock($setup["TransferOwnershipModal"], {
          key: 0,
          onClose: _cache[25] || (_cache[25] = ($event: any) => ($setup.showTransferOwnershipModal = false)),
          isOpen: $setup.showTransferOwnershipModal,
          lot: $setup.lot,
          estate: $setup.estate,
          onProceed: $setup.transferOwnership
        }, null, 8, ["isOpen", "lot", "estate"]))
      : _createCommentVNode("", true),
    _createVNode($setup["GiveReasonModal"], {
      modalTitle: `Provide a reason for terminate contract`,
      isOpen: $setup.showCancelContractModal,
      reasons: [...Object.values($setup.ReasonsForCancelEOI)],
      onConfirm: _cache[26] || (_cache[26] = ($event: any) => ($setup.onCancelContract($event))),
      onClose: _cache[27] || (_cache[27] = ($event: any) => ($setup.showCancelContractModal = false))
    }, null, 8, ["isOpen", "reasons"]),
    ($setup.showSendContractFormModal)
      ? (_openBlock(), _createBlock($setup["SendContractFormModal"], {
          key: 1,
          isOpen: $setup.showSendContractFormModal,
          showClose: false,
          estateId: $setup.estateId,
          lotId: $setup.lotId,
          onClose: _cache[28] || (_cache[28] = ($event: any) => ($setup.showSendContractFormModal = false))
        }, null, 8, ["isOpen", "estateId", "lotId"]))
      : _createCommentVNode("", true),
    ($setup.lot)
      ? (_openBlock(), _createBlock($setup["CreateHoldFromLandownerSideModal"], {
          key: 2,
          isOpen: $setup.showCreateInitialHoldModal,
          lot: $setup.lot,
          onCreated: $setup.onCreatedHold,
          onClose: _cache[29] || (_cache[29] = ($event: any) => ($setup.showCreateInitialHoldModal = false))
        }, null, 8, ["isOpen", "lot"]))
      : _createCommentVNode("", true),
    _withDirectives(_createVNode(_component_router_view, {
      tab: $setup.currentTab?.label,
      lot: $setup.lot,
      estate: $setup.estate,
      eois: $setup.eois?.eois,
      onUpdateLot: $setup.getLot,
      onUpdateEoi: $setup.getEois,
      onChangeTab: _cache[30] || (_cache[30] = ($event: any) => ($setup.changeTab('contract information forms'))),
      onLoading: _cache[31] || (_cache[31] = ($event: any) => ($setup.loading = true)),
      onAddDocument: _cache[32] || (_cache[32] = ($event: any) => ($setup.addDocument($event))),
      onDeleteDocument: _cache[33] || (_cache[33] = ($event: any) => ($setup.deleteDocument($event)))
    }, null, 8, ["tab", "lot", "estate", "eois"]), [
      [_vShow, !$setup.loading]
    ])
  ]))
}